export const PAGE_COUNT = 'contentPageCount';
export const ACTIVE_PAGE = 'activePage'
export const SCALE = 'scale'

export const OPEN_MAPPEN = 'Offene Mappen'
export const CLOSED_MAPPEN = 'Erledigte Mappen'
export const EXPIRED_MAPPEN = 'Abgelaufene Mappen'
